export default __webpack_public_path__ + "static/media/spare-part.7fd74960.svg";